var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.6A6.6 6.6 0 108 1.4a6.6 6.6 0 000 13.2z",
    stroke: "#A8AAAD",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19 3.992c-.814 0-1.452.231-1.925.693-.484.462-.715 1.1-.715 1.914h1.254c0-.473.088-.836.275-1.089.22-.297.561-.44 1.034-.44.374 0 .671.099.88.308.198.209.308.495.308.858 0 .275-.099.539-.297.781l-.132.154c-.715.638-1.144 1.1-1.287 1.397-.154.297-.22.66-.22 1.078V9.8H8.63v-.154a1.6 1.6 0 01.165-.726c.099-.198.242-.385.44-.539.528-.462.847-.759.946-.869.264-.352.407-.803.407-1.353 0-.671-.22-1.199-.66-1.584-.44-.396-1.023-.583-1.738-.583zm-.198 6.347a.804.804 0 00-.594.231.744.744 0 00-.253.594c0 .242.077.44.253.594a.812.812 0 00.594.242c.242 0 .44-.077.616-.231a.838.838 0 00.242-.605.812.812 0 00-.242-.594.874.874 0 00-.616-.231z",
    fill: "#A8AAAD"
  })));
}
export default __webpack_public_path__ + "static/question.cc2fb7ff.svg";
export { SvgQuestion as ReactComponent };